import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=768bcde7&lang=pug&"
import script from "./slider.vue?vue&type=script&lang=js&"
export * from "./slider.vue?vue&type=script&lang=js&"
import style0 from "./slider.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports